import React from "react";
import { CardComp } from "../../../components";
import PageWrapper from "../modules/PageWrapper";
import { useGetMemberSupportInfoQuery } from "../../../store/member/member-support";
import { BsEnvelope, BsTelephone, BsInfoCircle } from "react-icons/bs";
import TableSkeletonLoader from "../../../components/Common/TableSkeletonLoader";

const Support = () => {
  const {
    data: supportInfo,
    isLoading,
    isFetching,
  } = useGetMemberSupportInfoQuery();

  const email = supportInfo?.support_email;
  const phone = supportInfo?.support_phone;
  const instructions = supportInfo?.support_instructions;
  const isFallback = supportInfo?.is_fallback;

  if (isLoading || isFetching) {
    return (
      <PageWrapper title={"Support"}>
        <CardComp cardClassName="border-0 shadow-sm">
          <TableSkeletonLoader rows={5} columns={1} />
        </CardComp>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper title={"Support"}>
      <div className="space-y-4" data-tour="member-support-contact">
        {/* Info Card */}
        {isFallback && (
          <CardComp cardClassName="border-0 shadow-sm mb-4" cardBodyClassName="p-3">
            <div className="d-flex align-items-center">
              <BsInfoCircle className="me-2" style={{ color: "var(--color-secondary)", fontSize: "20px" }} />
              <p className="mb-0 text-blacklight small">
                Contact information provided by Super Admin
              </p>
            </div>
          </CardComp>
        )}

        {/* Email Card */}
        {email && (
          <CardComp cardClassName="border-0 shadow-sm">
            <div className="p-4">
              <div className="d-flex align-items-center mb-3">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "50px",
                    height: "50px",
                    background: "var(--color-primary-soft)",
                  }}
                >
                  <BsEnvelope style={{ color: "var(--color-primary)", fontSize: "24px" }} />
                </div>
                <div>
                  <h6 className="fw-bold text-black2 mb-1">Email Support</h6>
                  <p className="text-blacklight small mb-0">Contact us via email</p>
                </div>
              </div>
              <a
                href={`mailto:${email}`}
                className="text-decoration-none"
                style={{ color: "var(--color-secondary)" }}
              >
                <p className="mb-0 fw-2">{email}</p>
              </a>
            </div>
          </CardComp>
        )}

        {/* Phone Card */}
        {phone && (
          <CardComp cardClassName="border-0 shadow-sm">
            <div className="p-4">
              <div className="d-flex align-items-center mb-3">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "50px",
                    height: "50px",
                    background: "var(--color-secondary-soft)",
                  }}
                >
                  <BsTelephone style={{ color: "var(--color-secondary)", fontSize: "24px" }} />
                </div>
                <div>
                  <h6 className="fw-bold text-black2 mb-1">Phone Support</h6>
                  <p className="text-blacklight small mb-0">Call us directly</p>
                </div>
              </div>
              <a
                href={`tel:${phone}`}
                className="text-decoration-none"
                style={{ color: "var(--color-secondary)" }}
              >
                <p className="mb-0 fw-2">{phone}</p>
              </a>
            </div>
          </CardComp>
        )}

        {/* Instructions Card */}
        {instructions && (
          <CardComp cardClassName="border-0 shadow-sm" data-tour="member-support-instructions">
            <div className="p-4">
              <h6 className="fw-bold text-black2 mb-3">How to Apply for Support</h6>
              <div
                className="text-black1"
                style={{
                  whiteSpace: "pre-line",
                  lineHeight: "1.8",
                }}
              >
                {instructions}
              </div>
            </div>
          </CardComp>
        )}

        {/* Empty State */}
        {!email && !phone && !instructions && (
          <CardComp cardClassName="border-0 shadow-sm">
            <div className="p-5 text-center">
              <BsInfoCircle style={{ fontSize: "48px", color: "#a1a0a0", marginBottom: "1rem" }} />
              <p className="text-blacklight mb-0">
                Support information is not available at this time. Please contact your administrator.
              </p>
            </div>
          </CardComp>
        )}
      </div>
    </PageWrapper>
  );
};

export default Support;
